var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pd-24",
      class: {
        "col-xs-12 col-sm-6 col-md-4": _vm.widgetTrackplusFlag,
        "exp-pd-tp-0":
          _vm.panel &&
          _vm.panel.card_number != "2" &&
          _vm.panel.card_number != "3",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "expiry_pending",
          class: _vm.widgetTrackplusFlag ? "widget" : "",
        },
        [
          _c("h3", { staticClass: "title" }, [
            _vm.panel && _vm.panel.active
              ? _c("img", {
                  staticClass: "track_plus_icon_blue",
                  attrs: {
                    src: "/static/images/icons/track_plus_icon_blue.svg",
                  },
                })
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "cursor-pointer",
                class: { "pl-19": _vm.panel && _vm.panel.active },
                on: { click: _vm.goToLink },
              },
              [_vm._v("Expiry Status")]
            ),
          ]),
          _c(
            "div",
            { staticClass: "MT-25 MT-12" },
            _vm._l(_vm.expiration_details, function (item, key, index) {
              return _c("div", { key: index }, [
                _c(
                  "p",
                  { staticClass: "tab_expiry" },
                  [
                    key === "expired"
                      ? _c("span", [_vm._v("Expired")])
                      : _vm._e(),
                    key === "month"
                      ? _c("span", [_vm._v("Expiring this month")])
                      : _vm._e(),
                    key === "quarter"
                      ? _c("span", [_vm._v("Expiring next 3 months")])
                      : _vm._e(),
                    key === "year"
                      ? _c("span", [_vm._v("Expiring this year")])
                      : _vm._e(),
                    item.products && item.products.length > 0
                      ? _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              "popper-class": "popper-custom-class",
                              width: "200",
                              trigger: "hover",
                              disabled: _vm.openPopover,
                            },
                            on: { hide: _vm.$parent.hidePopover },
                            model: {
                              value: _vm.expiryVisible[index],
                              callback: function ($$v) {
                                _vm.$set(_vm.expiryVisible, index, $$v)
                              },
                              expression: "expiryVisible[index]",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "popper-height" },
                              _vm._l(item.products, function (expReg, index) {
                                return _c(
                                  "p",
                                  {
                                    key: index,
                                    staticClass: "cursor-pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "viewRegistration",
                                          expReg.rid,
                                          "expiry",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(expReg.name))]
                                )
                              }),
                              0
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "progress_count cursor-pointer",
                                attrs: { slot: "reference" },
                                on: { click: _vm.$parent.activatePopover },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(item.number))]
                            ),
                          ]
                        )
                      : _vm._e(),
                    item.products.length === 0
                      ? _c("span", { staticClass: "progress_count" }, [
                          _vm._v(_vm._s(item.number)),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "progress" }, [
                  _c("div", {
                    staticClass: "progress-bar",
                    class: {
                      red: key === "expired",
                      orange: key === "month",
                      blue: key === "quarter",
                      green: key === "year",
                    },
                    style: { width: item.number + "%" },
                    attrs: {
                      "aria-valuenow": item.number,
                      "aria-valuemin": 0,
                      "aria-valuemax": 100,
                    },
                  }),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }